import "../../../../js/slick.min";
import "../../../../libs/slick.css";
class SolutionAdditionalMaterials {
	static block_name = "b-solution-additional-materials";

	constructor($elem) {
		this.$elem = $elem;
	}

	onInit() {
		const it = this;


		const $sliderContainer = it.$elem.find(
			`.${SolutionAdditionalMaterials.block_name}__items`
		);

		$sliderContainer
			.slick({
				prevArrow: it.$elem.find(
					`.${SolutionAdditionalMaterials.block_name}__arrow--prev`
				),
				nextArrow: it.$elem.find(
					`.${SolutionAdditionalMaterials.block_name}__arrow--next`
				),
				slidesToShow: 3,
				dots: true,
				appendDots: it.$elem.find(
					`.${SolutionAdditionalMaterials.block_name}__dots`
				),
				responsive: [
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
						},
					},
					{
						breakpoint: 1080,
						settings: {
							slidesToShow: 2,
						},
					},
				],
			})
			.on("setPosition", function (event, slick) {
				if($(window).width() > 1200) {
					slick.$slides.css("height", slick.$slideTrack.height() + "px");
				}
			});

	}
}
export default SolutionAdditionalMaterials;
